import { emptyArray } from 'ui-components/default-props/empty';
import { CustomAttributeSortColumn, OrderByDirection } from '@shipstation/client-common/types/freight-requests';

import type { CustomAttributesState } from './ltl.custom-attributes.reducer';

export const selectCustomAttributeGridRows = (state: CustomAttributesState) => state.rows ?? emptyArray;

export const selectCustomAttributeGridPage = (state: CustomAttributesState) => state.page ?? 1;

export const selectCustomAttributeGridPageSize = (state: CustomAttributesState) => state.pageSize ?? 50;

export const selectCustomAttributeGridTotalCount = (state: CustomAttributesState) => state.totalRecords ?? 0;

export const selectCustomAttributeGridIsLoading = (state: CustomAttributesState) => state.isLoading ?? false;

export const selectCustomAttributeGridTypeIds = (state: CustomAttributesState) => state.typeIds ?? null;

export const selectCustomAttributeGridIsActiveFilter = (state: CustomAttributesState) =>
  state.isActiveFilter === undefined ? true : state.isActiveFilter;

export const selectCustomAttributeGridOrderBy = (state: CustomAttributesState) => state.orderBy ?? CustomAttributeSortColumn.Key;

export const selectCustomAttributeGridOrderByDirection = (state: CustomAttributesState) =>
  state.orderByDirection ?? OrderByDirection.Ascending;

export const selectCustomAttributeEditingDefinition = (state: CustomAttributesState) => state.editingDefinition ?? null;

export const selectCustomAttributeIsLoadingDefinition = (state: CustomAttributesState) => state.isLoadingDefinition ?? false;

export const selectCustomAttributeIsSaving = (state: CustomAttributesState) => state.isSaving ?? false;

export const selectCustomAttributeIsSaveError = (state: CustomAttributesState) => state.isSaveError ?? false;

export const selectCustomAttributeSaveErrorMessage = (state: CustomAttributesState) => state.saveErrorMessage ?? null;

export const selectCustomAttributeIsUpdatingStatus = (state: CustomAttributesState) => state.isUpdatingStatus ?? false;
